export default {
  //Executive Login
  employeeCode: "employeeCode",
  channel: "channel",
  product: "product",
  salesManager: "salesManager",
  businessManager: "businessManager",
  //
  birthDate: "birthDate",
  fixedIncome: "fixedIncome",
  variableIncome: "variableIncome",
  areaOfWork: "areaOfWork",
  firstName: "firstName",
  lastName: "lastName",
  emiratesID: "emiratesID",
  expiryDate: "expiryDate",
  passportExpiryDate: "passportExpiryDate",
  nationality: "nationality",
  email: "email",
  phoneNumber: "phoneNumber",
  OTPCode: "OTPCode",
  statementType: "statementType",
  consentPolitical: "consentPolitical",
  consentPoliticalOption: "consentPoliticalOption",
  promoCode: "promoCode",
  validateOTP: "validateOTP",
  promoCodeInput: "promoCodeInput",
  otpInput: "otpInput",
  promoCodeButton: "promoCodeButton",
  optValidateButton: "optValidateButton",
  mediumOfReceive: "mediumOfRecevingIncome",
  passportNumberIndentity: "passportNumberIndentity",
  ibanOrUploadStatement: "iban-or-upload-statement",
  compareCapthca: "Captcha",
  //Company
  workEmail: "workEmail",
  employmentType: "employmentType",
  companyName: "companyName",
  unlistedCompanyName: "unlistedCompanyName",
  companyNameSelfEmployed: "companyNameSelfEmployed",
  designation: "designation",
  workAmount: "workExperience",
  industry: "industry",
  companyAge: "companyAge",
  industryTypeEmplyoed: "industryTypeEmplyoed",
  industryTypeSelfEmplyoed: "industryTypeSelfEmplyoed",
  emirate: "emirate",
  bankAccount: "bankAccount",
  IBAN: "IBAN",
  IBANNumber: "IBANNumber",
  consolidatedStatement: "consolidatedStatement",
  consolidatedStatement2: "consolidatedStatement2",
  firstStatement: "firstStatement",
  secondStatement: "secondStatement",
  thirdStatement: "thirdStatement",
  cardLimit: "cardLimit",
  paymentDate: "paymentDate",
  appointmentDate: "appointmentDate",
  appointmentTime: "appointmentTime",
  appointmentPlace: "appointmentPlace",
  address: "address",
  number: "number",
  postalCode: "postalCode",

  additionalAddress: "additionalAddress",
  haveLoan: "haveLoan",
  haveCreditCard: "haveCreditCard",
  fullName: "fullName",
  livingTime: "livingTime",
  areaDubai: "areaDubai",
  upload: "upload",
  instalmentsAmount: "instalmentsAmount",
  residenceType: "residenceType",
  consent: "consent",
  gender: "gender",
  emiratesFrontCard: "emiratesFrontCard",
  emiratesBackCard: "emiratesBackCard",
  noticeUploads: "notice-uploads",
  adressCompanyName: "address-company-name",
  maritalStatus: "maritalStatus",
  fullNameRefernce: "referenceName",
  referencePhoneNumber: "referencePhoneNumber",
  fullNameHomecountry: "nameHomeCountry",
  homeCountryPhoneNumber: "homeCountryPhoneNumber",
  homeCountryPoBox: "homeCountryPoBox",
  paymentHoliday: "paymentHoliday",
  // offer
  passportNumber: "passportNumber",
  educationalLevel: "educationalLevel",
  salaryPaymentDay: "salaryPaymentDay",
  streetName: "streetName",
  poBox: "poBox",
  homeCountryAddress: "homeCountryAddress",
  homeCountryAdditionalAddress: "homeCountryAdditionalAddress",
  homeCountryNumber: "homeCountryNumber",
  homeCountryPoscode: "homeCountryPoscode",
  homeCountryCountry: "homeCountryCountry",
  homeCountryPhoneCountryCode: "homeCountryPhoneCountryCode",
  homeCountryPhone: "homeCountryPhone",
  referencesFullName: "referencesFullName",
  referencesPhone: "referencesPhone",
  referencesHomeCountryFullName: "referencesHomeCountryFullName",
  referencesHomeCountryPhoneCode: "referencesHomeCountryPhoneCode",
  referencesHomeCountryPhone: "referencesHomeCountryPhone",
  employerFullName: "employerFullName",
  employerPhone: "employerPhone",
  emiratesNBD: "emiratesNBD",
  ddaPaymentAmount: "ddaPaymentAmount",
  bankAccountTitle: "bankAccountTitle",
  amountToBorrow: "amount-to-borrow",
  monthlyInstalment: "monthly-instalment",
  amountOfInstalments: "amount-of-instalments",
  whatLoanFor: "what-loan-for",
  instalmentDueDate: "instalment-due-date",
  residentialAddress: "residential-address",
  residentialAdditionalAddress: "residential-additional-address",
  residentialNearestLandmark: "residential-nearest-landmark",
  residentialEmirate: "residential-emirate",
  addressLine1: "addressLine1",
  addressLine2: "addressLine2",
  homeCountryAddressLine1: "homeCountryAddressLine1",
  homeCountryAddressLine2: "homeCountryAddressLine2",
  countryHomeCountry: "HomeCountry",
  homeCountrayCountryCode: "countryCode",
  primaryAddress: "primaryAddress",
  homeAddress: "homeAddress",
  //for home option
  addressLine1Home: "addressLine1Home",
  addressLine2Home: "addressLine2Home",
  residentialEmirateHome: "residentialEmirateHome",
  homeCountryCountryHome: "homeCountryCountryHome",
  poBoxHome: "poBoxHome",
  fullNameRefernceHome: "fullNameRefernceHome",
  referencePhoneNumberHome: "referencePhoneNumberHome",
  fullNameHomecountryHome: "fullNameHomecountryHome",
  homeCountryPhoneCountryCodeHome: "homeCountryPhoneCountryCodeHome",
  homeCountryPhoneHome: "homeCountryPhoneHome",
  homeCountryAddressHome: "homeCountryAddressHome",
  homeCountryAdditionalAddressHome: "homeCountryAdditionalAddressHome",
  homeCountryCountryHome: "homeCountryCountryHome",
  homeCountryPoscodeHome: "homeCountryPoscodeHome",

  // example-custom-flow
  mandatoryOne: "mandatory-1",
  mandatoryTwo: "mandatory-2",
  mandatoryThree: "mandatory-3",
  mandatoryFour: "mandatory-4",
  mandatoryFive: "mandatory-5",
  mandatorySix: "mandatory-6",
  optionalOne: "optional-1",
  optionalTwo: "optional-2",
  // insurances
  otpComponent: "OTP-component",
  additionalInfo: "additionalInfo",
  // needs review
  firstSalaryFile: "first-salary-file",
  secondSalaryFile: "second-salary-file",
  thirdSalaryFile: "third-salary-file",
  feedback: "feedback",
  payslipOnePassword: "payslip-1-Password",
  payslipTwoPassword: "payslip-2-Password",
  payslipThreePassword: "payslip-3-Password",
  // Stored Value Card
  emiratesIDExpiry: "emirates-id-expiry",
  acceptOfferTerms: "accept-offer-terms",
  nameOnCard: "name-on-card",
  pictureOnCard: "picture-on-card",
  consentCardAcceptance: "consent-card-acceptance",
  nearestLandmark: "nearest-landmark",
  areaStreetName: "area-street-name",
  accountPassword: "account-password",
  // Credit Card
  creditCardLimit: "credit-card-limit",
  doubleSecureNomineeFullName: "double-secure-nominee-full-name",
  doubleSecureNomineebirthDate: "double-secure-nominee-birth-date",
  doubleSecureNomineeRelationship: "double-secure-nominee-relationship",
  doubleSecureNomineePhone: "doubleSecureNomineePhone",
  doubleSecureNomineePhoneCountryCode: "doubleSecureNomineePhoneCountryCode",
  // button text
  acceptOfferText:
    '<span class="visible-until-sm">Accept</span><span class="hidden-until-sm">Confirm</span>',
  rejectOfferText:
    '<span class="visible-until-sm">Reject</span><span class="hidden-until-sm">Reject offer</span>',
  // Supplementary Cards
  supplementaryCardFullName: "supplementary-card-full-name",
  supplementaryCardFirstName: "supplementary-card-first-name",
  supplementaryCardLastName: "supplementary-card-last-name",
  supplementaryCardGender: "supplementary-card-gender",
  supplementaryCardRelationship: "supplementary-card-relationship",
  supplementaryCardEmirates: "supplementary-card-emirates",
  supplementaryCardLimit: "supplementary-card-limit",
  supplementaryBirthDate: "supplementary-date-of-birth",
  supplementaryNationality: "supplementary-nationality",
  supplementaryNameOnCard: "supplementary-name-on-card",
  supplementaryCardLimit: "supplementary-card-limit",
  //nbc card
  spending: "spending",
  salary: "salary",
  rewards: "rewards",
  use: "use",
  uselong: "uselong",
  other: "other",
  howmuch: "howmuch",
  instalments: "instalments",
  income: "income",
  //Insurance
  insuranceType: "insuranceType",
  //referalprogram
  referalCashUp: "referalCashUp",
  referalMileUp: "referalMileUp",
  referalCashUpButton: "referalCashUpButton",
  referalMileUpButton: "referalMileUpButton",
  referFirstName: "referFirstName",
  referLastName: "referLastName",
  referEmail: "referEmail",
  referMobileNumber: "referMobileNumber",
  //Balance Transfer
  btBankName: "btBankName",
  btCreditCardNumber: "btCreditCardNumber",
  btCreditLimit: "btCreditLimit",
  btTransferAmount: "btTransferAmount",
  btaddCardTwo: "btaddCardTwo",
  btBankName2: "btBankName2",
  btCreditCardNumber2: "btCreditCardNumber2",
  btCreditLimit2: "btCreditLimit2",
  btTransferAmount2: "btTransferAmount2",
  btaddCardThree: "btaddCardThree",
  btBankName3: "btBankName3",
  btCreditCardNumber3: "btCreditCardNumber3",
  btCreditLimit3: "btCreditLimit3",
  btTransferAmount3: "btTransferAmount3",
  btaddCardFour: "btaddCardFour",
  btBankName4: "btBankName4",
  btCreditCardNumber4: "btCreditCardNumber4",
  btCreditLimit4: "btCreditLimit4",
  btTransferAmount4: "btTransferAmount4",
  btType: "btType",
  //corporate
  productInterested: "productInterested",
  emirates: "emirates",
  uAESince: "UAESince"
};
